export * from './Route';
export * from './Switch';
export * from './NavProvider';
export * from './RouterProvider';
export * from './Redirect';
export * from './Link';
export * from './InjectMagicRouter';
export {
  createNavParams, NavParams, ValOrFunc, Match, StringOrLocationDescriptorObject,
  ToProps, createHandleAnchorClick, navigate,
} from './utils';



// WEBPACK FOOTER //
// ./src/D:/Realytics/repo/react-router-magic/~/tslint-loader!./src/index.ts